import {
  GET_CONTAINERS_LIST_IN_PROGRESS,
  GET_CONTAINERS_LIST_SUCCESS,
  GET_CONTAINERS_LIST_FAIL,
  GET_CONTAINERS_LIST_FILTERS_IN_PROGRESS,
  GET_CONTAINERS_LIST_FILTERS_SUCCESS,
  GET_CONTAINERS_LIST_FILTERS_FAIL,
  GET_CONTAINERS_LIST_COUNT_IN_PROGRESS,
  GET_CONTAINERS_LIST_COUNT_SUCCESS,
  GET_CONTAINERS_LIST_COUNT_FAIL,
  GET_CONTAINERS_LIST_TOTAL_LOAD_IN_PROGRESS,
  GET_CONTAINERS_LIST_TOTAL_LOAD_SUCCESS,
  GET_CONTAINERS_LIST_TOTAL_LOAD_FAIL,
} from "../constants";
import { LOGOUT } from "../../authentication/constants";

const initialState = {
  list: [],
  inProgress: false,
  filtersInProgress: false,
  error: false,
  filters: {},
  count: 0,
  totalLoad: 0,
};

/**
 * Containers reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function containers(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_CONTAINERS_LIST_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
        error: false,
      };

    case GET_CONTAINERS_LIST_SUCCESS:
      return {
        ...state,
        list: payload.list,
        inProgress: false,
      };

    case GET_CONTAINERS_LIST_FAIL:
      return {
        ...state,
        inProgress: false,
        error: true,
      };

    case GET_CONTAINERS_LIST_FILTERS_IN_PROGRESS:
      return {
        ...state,
        filtersInProgress: true,
        error: false,
      };

    case GET_CONTAINERS_LIST_FILTERS_SUCCESS:
      return {
        ...state,
        filters: payload.filters,
        filtersInProgress: false,
      };

    case GET_CONTAINERS_LIST_FILTERS_FAIL:
      return {
        ...state,
        filtersInProgress: false,
        error: true,
      };

    // TODO Add countInProgress so we can disable pagination while we are fetching the count ?
    case GET_CONTAINERS_LIST_COUNT_IN_PROGRESS:
      return {
        ...state,
        // inProgress: true,
        error: false,
      };

    case GET_CONTAINERS_LIST_COUNT_SUCCESS:
      return {
        ...state,
        count: payload.count,
        // inProgress: false,
      };

    case GET_CONTAINERS_LIST_COUNT_FAIL:
      return {
        ...state,
        // inProgress: false,
        error: true,
      };

    case GET_CONTAINERS_LIST_TOTAL_LOAD_IN_PROGRESS:
      return {
        ...state,
        // inProgress: true,
        error: false,
      };

    case GET_CONTAINERS_LIST_TOTAL_LOAD_SUCCESS:
      return {
        ...state,
        totalLoad: payload.totalLoad,
        // inProgress: false,
      };

    case GET_CONTAINERS_LIST_TOTAL_LOAD_FAIL:
      return {
        ...state,
        // inProgress: false,
        error: true,
      };

    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
